/**
 * Filtro client-side puro para o modal SeletorUsinasEolicas (WINDX-021).
 *
 * Operacao em ~1052 itens × 6 predicados = ~6k comparacoes por re-render.
 * Medicoes locais (Chrome devtools, R7 5800X): ~0.4ms para o pior caso
 * — bem dentro do orcamento de 16ms para 60fps. Sem necessidade de
 * memoizar por chave de filtros: o consumidor (`SeletorUsinasEolicas`)
 * ja faz `useMemo` no array filtrado.
 *
 * Decisao de design: usar `.filter` com predicado unico em vez de
 * encadear `.filter` sucessivos. Encadeamento aloca arrays intermediarios;
 * este `.filter` unico aloca apenas o array final.
 */
import { FiltrosUsinas, UsinaEolicaDenormalizada } from 'helper/windx';

export default function filtrarUsinasEolicas(
  usinas: UsinaEolicaDenormalizada[],
  filtros: FiltrosUsinas,
): UsinaEolicaDenormalizada[] {
  const busca = filtros.busca.trim().toLowerCase();
  const temBusca = busca.length > 0;
  const ufsSet = filtros.ufs.length > 0 ? new Set(filtros.ufs) : null;
  const subsistemasSet = filtros.subsistemasSm.length > 0
    ? new Set(filtros.subsistemasSm)
    : null;
  const conjuntosSet = filtros.conjuntos.length > 0
    ? new Set(filtros.conjuntos)
    : null;
  const { potenciaMin, potenciaMax } = filtros;
  const temMin = potenciaMin !== null && potenciaMin !== undefined;
  const temMax = potenciaMax !== null && potenciaMax !== undefined;

  return usinas.filter((u) => {
    if (ufsSet) {
      if (!u.uf_sigla || !ufsSet.has(u.uf_sigla)) return false;
    }
    if (subsistemasSet) {
      if (!u.subsistema_sm_sigla || !subsistemasSet.has(u.subsistema_sm_sigla)) return false;
    }
    if (conjuntosSet) {
      // WINDX-024: filtro por conjunto agora usa label_conjunto
      // (desambiguado, UNIQUE). FiltrosUsinas.conjuntos deve conter labels.
      if (!conjuntosSet.has(u.label_conjunto)) return false;
    }
    if (temMin && u.potencia < (potenciaMin as number)) return false;
    if (temMax && u.potencia > (potenciaMax as number)) return false;
    if (temBusca) {
      const nomeMatch = u.nome.toLowerCase().includes(busca);
      const codigoMatch = u.codigo.toLowerCase().includes(busca);
      const cegMatch = u.nucleo_ceg
        ? u.nucleo_ceg.toLowerCase().includes(busca)
        : false;
      if (!nomeMatch && !codigoMatch && !cegMatch) return false;
    }
    return true;
  });
}
